import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=a15a985e&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,SlidersText: require('/home/nvpa/nvpa-corporate/nuxt/components/sliders/Text.vue').default,SlidersImage: require('/home/nvpa/nvpa-corporate/nuxt/components/sliders/Image.vue').default})
